module.exports = __webpack_public_path__ + "static/media/clock-blue.31602465.svg";